import React, { useEffect, useRef, useState } from 'react';
import { Box, Paper, Stack, Typography } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import { useSelector } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';
import { default as Swal, default as swal } from 'sweetalert2';
import { createLevel1Data } from '../../../../api/restApi';
import TableGrid from '../../../../components/Accounts/Account/TableGrid';
import Level1CodeDialog from '../../../../components/Accounts/Account/level1CodeDialog';
import { updateAllLevels } from '../../../../store/action';
import { EncodeLevel1Code, GetMaxCode, columns } from '../../../../utils/Level/utils';
import { deleteLevel1, updateLevel1 } from '../../../../utils/endPoints';
import { useAppDispatch } from '../../../../utils/hooks';
// import theme from 'theme';
const Level_1 = () => {
  const level1 = useSelector(state => state.accountLevels.level1);
  const [code, setCode] = useState('');
  const [description, setDescription] = useState('');
  const [saveDisable, setSaveDisable] = useState(true);
  const [cancelDisable, setCancelDisable] = useState(true);
  const [deleteDisable, setDeleteDisable] = useState(true);
  const [showEntryForm, setShowEntryForm] = useState(false);
  const [isUpdateLevel1, setUpdateLevel1] = useState(false);
  const [loading, setLoading] = useState(false);
  const [level1Dcode, setLevel1DCode] = useState('');

  const dispatch = useAppDispatch();

  const descriptionRef = useRef();

  function addNewLevelCode() {
    setUpdateLevel1(false);
    setDescription('');
    setShowEntryForm(true);
    setCode(EncodeLevel1Code(GetMaxCode(level1)));
  }

  function gridUpdateFromFirebase(data) {
    setCode(EncodeLevel1Code(GetMaxCode(data)));
    DisableButtonsView();
  }

  useEffect(() => {
    gridUpdateFromFirebase(level1);
  }, [level1]);

  useEffect(() => {
    console.log('i am level2', level1);
    if (level1) {
      let tempArray = level1.filter(function (el) {
        return el.fullcode;
      });
      console.log(tempArray);
      setLevel1DCode(tempArray.code);
    }
  }, [level1]);

  const DisableButtonsView = () => {
    setDescription('');
    setSaveDisable(true);
    setCancelDisable(true);
    setDeleteDisable(true);
    if (descriptionRef.current) {
      descriptionRef.current.focus();
    }
  };
  const checkCode = async data => {
    console.log(data);
    setShowEntryForm(false);
    setDescription('');
    let isCodeAvailable = true;
    console.log(level1);
    level1.map(item => {
      if (data.code === item.code) {
        isCodeAvailable = false;
      }
    });
    if (isCodeAvailable === false) {
      Swal.fire('Code already in used.').then(async result => {});
    } else {
      let res = await createLevel1Data(data.code, data);
      if (res?.msg.endsWith('successfully')) {
        toast.success(res.msg);
        updateAllLevels(dispatch);
      } else {
        toast.error('Error! Failed To save');
      }
    }
  };

  async function updateLevel1Data(event, params) {
    console.log(params);
    setUpdateLevel1(true);
    setCode(params.row.code);
    setDescription(params.row.Discription);
    setShowEntryForm(true);
  }

  function updateLevel1DataQuery(data) {
    setShowEntryForm(false);
    swal
      .fire({
        title: 'Are you sure to update existing code?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, update it!',
      })
      .then(async result => {
        setLoading(true);
        if (result.value) {
          const res = await updateLevel1(data.code, data);
          console.log(res);
          if (res?.msg.endsWith('successfully')) {
            toast.success(res.msg);
            updateAllLevels(dispatch);
          } else {
            toast.error('Failed to Update!');
          }
          setLoading(false);
        } else {
          setLoading(false);
        }
      });
    return;
  }

  async function deleteLevel1Data(data) {
    setShowEntryForm(false);
    swal
      .fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!',
      })
      .then(async result => {
        setLoading(true);
        if (result.value) {
          const res = await deleteLevel1(data.code);
          console.log(res);
          if (res?.msg.endsWith('successfully')) {
            setLoading(false);
            toast.success('Deleted successfully!');
            setLoading(false);
            updateAllLevels(dispatch);
          } else {
            setLoading(false);
            swal
              .fire(
                'Failed to delete! Level1 code cannot be deleted if child vouchers exists.',
              )
              .then(async res => {});
            toast.error('Failed to Delete!');
          }
        } else {
          setLoading(false);
        }
      });
  }

  return (
    <Paper>
      <CssBaseline />
      <Box sx={{ flexGrow: 1 ,marginTop:'1rem'}}>
        <Stack alignItems="center">
          <Typography variant="h4" component="h2" gutterBottom mt={0}>
            Chart of Acc Level '1' List
          </Typography>{' '}
        </Stack>

        {/* <Grid container justifyContent="center" textAlign="center" mt={2}>
        <Grid item xs={12} sm={6}> */}
        {/* <Button variant="contained" onClick={addNewLevelCode}>
        Add
      </Button> */}
        <Stack alignItems="center">
          <TableGrid
            rows={level1.map((item, index) => {
              return { id: index + 1, ...item };
            })}
            columns={columns}
            onCellDoubleClick={(params, event) => {
              updateLevel1Data(event, params);
            }}
            updateLevel1Data={updateLevel1Data}
            addNewLevelCode={addNewLevelCode}
          />
        </Stack>
        {/* </Grid>
      </Grid> */}
        <ToastContainer
          position="bottom-center"
          autoClose={2000}
          hideProgressBar={true}
          closeOnClick={true}
          progress={undefined}
        />

        {showEntryForm ? (
          <div>
            <Level1CodeDialog
              okCallback={data => {
                checkCode(data);
              }}
              cancelCallback={() => {
                setShowEntryForm(false);
              }}
              updateCallback={data => {
                updateLevel1DataQuery(data);
              }}
              deleteCallback={data => {
                deleteLevel1Data(data);
              }}
              newCode={code}
              l1code={level1Dcode}
              defaultDescription={description}
              visible={showEntryForm}
              updateLevel1={isUpdateLevel1}
            ></Level1CodeDialog>
          </div>
        ) : (
          <></>
        )}
      </Box>
    </Paper>
  );
};

export default Level_1;
